var PresentersBase, SharedUtilsHelper, SupportAPIHelper, SupportUtilsHelper;

PresentersBase = require('../../../backbone_base/frontend/presenters/base');

SupportUtilsHelper = require('../../../support/frontend/helpers/utils');

SupportAPIHelper = require('../../../support/frontend/helpers/API');

SharedUtilsHelper = {
  toHtml: (function(_this) {
    return function(template, hash, scope) {
      if ((template != null ? template.render : void 0) != null) {
        return template.render(PresentersBase.toHashWithHelpers(hash, scope));
      }
    };
  })(this),
  redirectToFaq: function() {
    return window.location.href = "" + window.FAQBASEURL;
  },
  redirectToHelpWizard: function() {
    return window.location.href = "" + window.SUPPORTBASEURL;
  },
  scrollTo: function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  },
  toggleCallUs: function(id) {
    var experiment;
    addWrapperLinkOverCallUs();
    experiment = $('span.lnk-call-us').attr('id');
    $('span.lnk-call-us').removeAttr('data-bhw-path');
    $('span.lnk-call-us').removeAttr('data-bhw');
    $('span.lnk-call-us').attr("data-bhw", "phone-number-" + experiment + "-" + id);
    return $('span.lnk-call-us').data("bhw", "phone-number-" + experiment + "-" + id);
  },
  addWrapperLinkOverCallUs: function() {
    $('.contact-number').addClass('hide');
    return $('span.lnk-call-us').addClass('lnk');
  },
  propagateEventBeforeReplacingElements: function(cb) {
    setTimeout(cb);
    return true;
  },
  removeSpecificParamFromUrl: function(url, parameter) {
    var hash, hashPresent, i, pars, prefix, queryString, urlBase, urlparts;
    if (url.indexOf('#') > 0) {
      hashPresent = true;
      hash = url.substr(url.indexOf('#') + 1);
    }
    urlparts = url.split("?");
    if (urlparts.length >= 2) {
      urlBase = urlparts.shift();
      queryString = urlparts.join("?");
      prefix = encodeURIComponent(parameter) + "=";
      pars = queryString.split(/[&;]/g);
      i = pars.length;
      while (i-- > 0) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlBase + "?" + pars.join("&");
    }
    if (url.indexOf('#') === -1 && hashPresent) {
      url = url + '#' + hash;
    }
    return url;
  },
  abortAjaxRequests: function(requests) {
    _.each(requests, function(req) {
      return req.abort();
    });
    return null;
  },
  startTimer: function(timer) {},
  stopTimer: function(timer) {},
  isIntl: function() {
    var ref;
    return checkIfIsEMEAByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isUS: function() {
    var ref;
    return checkIfIsUSByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isNeedish: function() {
    var ref;
    return checkIfIsNEEDISHByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  checkIfIsUSByCountry: function(country) {
    return getCountryCluster(country) === 'US';
  },
  checkIfIsEMEAByCountry: function(country) {
    return getCountryCluster(country) === 'EMEA';
  },
  checkIfIsNEEDISHByCountry: function(country) {
    return getCountryCluster(country) === 'NEEDISH';
  },
  checkIfIsUSByCountryCluster: function(countryCluster) {
    return countryCluster === 'US';
  },
  checkIfIsEMEAByCountryCluster: function(countryCluster) {
    return countryCluster === 'EMEA';
  },
  checkIfIsNEEDISHByCountryCluster: function(countryCluster) {
    return countryCluster === 'NEEDISH';
  },
  getCountryCluster: function(country) {
    if (country != null) {
      country = country.toUpperCase();
    }
    if (country === 'US' || country === 'IN') {
      return country;
    }
    if (country === 'PH' || country === 'TH') {
      return 'ASIA';
    }
    if (country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
      return 'NEEDISH';
    }
    return 'EMEA';
  },
  getCallUsMsg: function() {
    var customPhoneNumber;
    customPhoneNumber = getCustomPhoneNumber();
    if (customPhoneNumber != null) {
      return I18n.translate('js.modules.shared.call_us_message_with_custom_phone_number', {
        custom_phone_number: customPhoneNumber
      });
    } else {
      return I18n.translate('js.modules.shared.call_us_message');
    }
  },
  getCustomPhoneNumber: function() {
    var dealType, ref;
    dealType = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if ((typeof phoneNumbers !== "undefined" && phoneNumbers !== null ? phoneNumbers[dealType] : void 0) != null) {
      return phoneNumbers[dealType].custom;
    }
  },
  evaluate: function(key) {
    return (key != null) && (key === true || key === "true");
  },
  isCMSEnabled: function() {
    return (typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0) || !isUS();
  },
  showDOMElems: function(DOMElems) {
    addShowClass(DOMElems);
    return removeHideClass(DOMElems);
  },
  showDOMElemsInline: function(DOMElems) {
    removeHideClass(DOMElems);
    return addInlineClass(DOMElems);
  },
  hideDOMElems: function(DOMElems) {
    removeShowClass(DOMElems);
    return addHideClass(DOMElems);
  },
  addShowClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'show');
  },
  addInlineClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'display-inline');
  },
  removeDOMElemsInline: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'display-inline');
  },
  removeHideClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'hide');
  },
  removeShowClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'show');
  },
  addHideClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'hide');
  },
  addBtnPrimaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-primary');
  },
  addBtnSecondaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-invert');
  },
  addPreferredContactClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'preferred-contact-channel');
  },
  removeBtnPrimaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-primary');
  },
  removeBtnSecondaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-invert');
  },
  removePreferredContactClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'preferred-contact-channel');
  },
  addBloodHoundTagToDOMElems: function(DOMElems, tagName) {
    return manipulateDOMElems(DOMElems, window.addBloodHoundTagToDOMElem, tagName);
  },
  addClassToDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.addClassToDOMElem, className);
  },
  removeClassFromDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.removeClassFromDOMElem, className);
  },
  manipulateDOMElems: function(DOMElems, manipulateDOMElem, CSSSelector) {
    DOMElems = getInArrayFormat(DOMElems);
    return _.each(DOMElems, (function(_this) {
      return function(DOMElem, index) {
        return manipulateDOMElem(DOMElem, CSSSelector);
      };
    })(this));
  },
  addClassToDOMElem: function(DOMElem, className) {
    return DOMElem.addClass(className);
  },
  addBloodHoundTagToDOMElem: function(DOMElem, tagName) {
    DOMElem.removeAttr('data-bhw-path');
    DOMElem.removeAttr('data-bhw');
    DOMElem.attr("data-bhw", tagName);
    return DOMElem.data("bhw", tagName);
  },
  removeClassFromDOMElem: function(DOMElem, className) {
    return DOMElem.removeClass(className);
  },
  getInArrayFormat: function(elements) {
    if (_.isArray(elements)) {
      return elements;
    } else {
      return [elements];
    }
  },
  createTicket: (function(_this) {
    return function(data, successCb, errorCb, loadElem, loadingElemHeight) {
      data.is_costco_deal = SupportUtilsHelper.isCostcoDeal();
      return propagateEventBeforeReplacingElements(function() {
        var method, ref, tHubData, url;
        SupportUtilsHelper.showLoading(loadElem, loadingElemHeight);
        url = window.SUPPORTBASEURL + "/ticket/create";
        method = "POST";
        tHubData = {
          ticketParams: data,
          user: (ref = window.currentUser) != null ? ref.id : void 0
        };
        TrackingHub.add('ticket-create-params', {
          params: tHubData
        });
        return SupportAPIHelper.call(url, method, data, successCb, errorCb, false);
      });
    };
  })(this),
  isCostcoRelatedFAQ: function() {
    var currentArticleId, currentBreadcrumpsId;
    currentBreadcrumpsId = $('.breadcrumps_text').attr('breadcrumps_id');
    if (isCostcoSpecificTopicId(currentBreadcrumpsId)) {
      return true;
    }
    currentArticleId = $('.link').attr('inbenta_contentid');
    if (isCostcoSpecificArticle(currentArticleId)) {
      return true;
    }
    return false;
  },
  isCostcoSpecificTopicId: function(currentTopicId) {
    var costcoTopicIds, ref, ref1;
    costcoTopicIds = (ref = window.costcoConfig) != null ? (ref1 = ref.faq) != null ? ref1.breadcrumps_ids : void 0 : void 0;
    return (currentTopicId != null) && (costcoTopicIds != null) && costcoTopicIds.includes(currentTopicId);
  },
  isCostcoSpecificArticle: function(currentArticleId) {
    var costcoArticleIds, ref, ref1;
    costcoArticleIds = (ref = window.costcoConfig) != null ? (ref1 = ref.faq) != null ? ref1.article_ids : void 0 : void 0;
    return (currentArticleId != null) && (costcoArticleIds != null) && costcoArticleIds.includes(currentArticleId);
  }
};

module.exports = SharedUtilsHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC9oZWxwZXJzL3V0aWxzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvaGVscGVycy91dGlscy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLEdBQWlCLE9BQUEsQ0FBUSxpREFBUjs7QUFDakIsa0JBQUEsR0FBcUIsT0FBQSxDQUFRLHlDQUFSOztBQUNyQixnQkFBQSxHQUFtQixPQUFBLENBQVEsdUNBQVI7O0FBRW5CLGlCQUFBLEdBQ0U7RUFBQSxNQUFBLEVBQVEsQ0FBQSxTQUFBLEtBQUE7V0FBQSxTQUFDLFFBQUQsRUFBVyxJQUFYLEVBQWlCLEtBQWpCO01BQ04sSUFBRyxxREFBSDtlQUNFLFFBQVEsQ0FBQyxNQUFULENBQWdCLGNBQWMsQ0FBQyxpQkFBZixDQUFpQyxJQUFqQyxFQUF1QyxLQUF2QyxDQUFoQixFQURGOztJQURNO0VBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFSO0VBSUEsYUFBQSxFQUFnQixTQUFBO1dBQ2QsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFoQixHQUF1QixFQUFBLEdBQUcsTUFBTSxDQUFDO0VBRG5CLENBSmhCO0VBT0Esb0JBQUEsRUFBdUIsU0FBQTtXQUNyQixNQUFNLENBQUMsUUFBUSxDQUFDLElBQWhCLEdBQXVCLEVBQUEsR0FBRyxNQUFNLENBQUM7RUFEWixDQVB2QjtFQVVBLFFBQUEsRUFBVyxTQUFDLFVBQUQ7QUFDVCxRQUFBO0lBQUEsSUFBRyxVQUFIO01BQ0UsSUFBQSxHQUNFO1FBQUEsU0FBQSwyQ0FBOEIsQ0FBRSxZQUFoQzs7YUFDRixDQUFBLENBQUUsWUFBRixDQUFlLENBQUMsT0FBaEIsQ0FBd0IsSUFBeEIsRUFBOEIsSUFBOUIsRUFIRjs7RUFEUyxDQVZYO0VBZ0JBLFlBQUEsRUFBYyxTQUFDLEVBQUQ7QUFDWixRQUFBO0lBQUEsd0JBQUEsQ0FBQTtJQUNBLFVBQUEsR0FBYSxDQUFBLENBQUUsa0JBQUYsQ0FBcUIsQ0FBQyxJQUF0QixDQUEyQixJQUEzQjtJQUNiLENBQUEsQ0FBRSxrQkFBRixDQUFxQixDQUFDLFVBQXRCLENBQWlDLGVBQWpDO0lBQ0EsQ0FBQSxDQUFFLGtCQUFGLENBQXFCLENBQUMsVUFBdEIsQ0FBaUMsVUFBakM7SUFDQSxDQUFBLENBQUUsa0JBQUYsQ0FBcUIsQ0FBQyxJQUF0QixDQUEyQixVQUEzQixFQUF1QyxlQUFBLEdBQWdCLFVBQWhCLEdBQTJCLEdBQTNCLEdBQThCLEVBQXJFO1dBQ0EsQ0FBQSxDQUFFLGtCQUFGLENBQXFCLENBQUMsSUFBdEIsQ0FBMkIsS0FBM0IsRUFBa0MsZUFBQSxHQUFnQixVQUFoQixHQUEyQixHQUEzQixHQUE4QixFQUFoRTtFQU5ZLENBaEJkO0VBd0JBLHdCQUFBLEVBQTBCLFNBQUE7SUFDeEIsQ0FBQSxDQUFFLGlCQUFGLENBQW9CLENBQUMsUUFBckIsQ0FBOEIsTUFBOUI7V0FDQSxDQUFBLENBQUUsa0JBQUYsQ0FBcUIsQ0FBQyxRQUF0QixDQUErQixLQUEvQjtFQUZ3QixDQXhCMUI7RUE0QkEscUNBQUEsRUFBdUMsU0FBQyxFQUFEO0lBQ3JDLFVBQUEsQ0FBVyxFQUFYO0FBQ0EsV0FBTztFQUY4QixDQTVCdkM7RUFnQ0EsMEJBQUEsRUFBNEIsU0FBQyxHQUFELEVBQU0sU0FBTjtBQUMxQixRQUFBO0lBQUEsSUFBRyxHQUFHLENBQUMsT0FBSixDQUFZLEdBQVosQ0FBQSxHQUFtQixDQUF0QjtNQUNFLFdBQUEsR0FBYztNQUNkLElBQUEsR0FBTyxHQUFHLENBQUMsTUFBSixDQUFXLEdBQUcsQ0FBQyxPQUFKLENBQVksR0FBWixDQUFBLEdBQWlCLENBQTVCLEVBRlQ7O0lBR0EsUUFBQSxHQUFXLEdBQUcsQ0FBQyxLQUFKLENBQVUsR0FBVjtJQUNYLElBQUcsUUFBUSxDQUFDLE1BQVQsSUFBbUIsQ0FBdEI7TUFDRSxPQUFBLEdBQVUsUUFBUSxDQUFDLEtBQVQsQ0FBQTtNQUNWLFdBQUEsR0FBYyxRQUFRLENBQUMsSUFBVCxDQUFjLEdBQWQ7TUFDZCxNQUFBLEdBQVMsa0JBQUEsQ0FBbUIsU0FBbkIsQ0FBQSxHQUFnQztNQUN6QyxJQUFBLEdBQU8sV0FBVyxDQUFDLEtBQVosQ0FBa0IsT0FBbEI7TUFDUCxDQUFBLEdBQUksSUFBSSxDQUFDO0FBRVQsYUFBTSxDQUFBLEVBQUEsR0FBTSxDQUFaO1FBRUUsSUFBcUIsSUFBSyxDQUFBLENBQUEsQ0FBRSxDQUFDLFdBQVIsQ0FBb0IsTUFBcEIsRUFBNEIsQ0FBNUIsQ0FBQSxLQUFvQyxDQUFDLENBQTFEO1VBQUEsSUFBSSxDQUFDLE1BQUwsQ0FBWSxDQUFaLEVBQWUsQ0FBZixFQUFBOztNQUZGO01BR0EsR0FBQSxHQUFNLE9BQUEsR0FBVSxHQUFWLEdBQWdCLElBQUksQ0FBQyxJQUFMLENBQVUsR0FBVixFQVZ4Qjs7SUFXQSxJQUFHLEdBQUcsQ0FBQyxPQUFKLENBQVksR0FBWixDQUFBLEtBQW9CLENBQUMsQ0FBckIsSUFBMkIsV0FBOUI7TUFDRSxHQUFBLEdBQU0sR0FBQSxHQUFNLEdBQU4sR0FBWSxLQURwQjs7V0FFQTtFQWxCMEIsQ0FoQzVCO0VBb0RBLGlCQUFBLEVBQW1CLFNBQUMsUUFBRDtJQUNqQixDQUFDLENBQUMsSUFBRixDQUFPLFFBQVAsRUFBaUIsU0FBQyxHQUFEO2FBQ2YsR0FBRyxDQUFDLEtBQUosQ0FBQTtJQURlLENBQWpCO1dBRUE7RUFIaUIsQ0FwRG5CO0VBeURBLFVBQUEsRUFBWSxTQUFDLEtBQUQsR0FBQSxDQXpEWjtFQTREQSxTQUFBLEVBQVcsU0FBQyxLQUFELEdBQUEsQ0E1RFg7RUE4REEsTUFBQSxFQUFRLFNBQUE7QUFDTixRQUFBO1dBQUEsNkJBQUEscUNBQTRDLENBQUUsZ0JBQTlDO0VBRE0sQ0E5RFI7RUFpRUEsSUFBQSxFQUFNLFNBQUE7QUFDSixRQUFBO1dBQUEsMkJBQUEscUNBQTBDLENBQUUsZ0JBQTVDO0VBREksQ0FqRU47RUFvRUEsU0FBQSxFQUFXLFNBQUE7QUFDVCxRQUFBO1dBQUEsZ0NBQUEscUNBQStDLENBQUUsZ0JBQWpEO0VBRFMsQ0FwRVg7RUF1RUEsb0JBQUEsRUFBdUIsU0FBQyxPQUFEO1dBQ3JCLGlCQUFBLENBQWtCLE9BQWxCLENBQUEsS0FBOEI7RUFEVCxDQXZFdkI7RUEwRUEsc0JBQUEsRUFBeUIsU0FBQyxPQUFEO1dBQ3ZCLGlCQUFBLENBQWtCLE9BQWxCLENBQUEsS0FBOEI7RUFEUCxDQTFFekI7RUE2RUEseUJBQUEsRUFBNEIsU0FBQyxPQUFEO1dBQzFCLGlCQUFBLENBQWtCLE9BQWxCLENBQUEsS0FBOEI7RUFESixDQTdFNUI7RUFnRkEsMkJBQUEsRUFBOEIsU0FBQyxjQUFEO1dBQzVCLGNBQUEsS0FBa0I7RUFEVSxDQWhGOUI7RUFtRkEsNkJBQUEsRUFBZ0MsU0FBQyxjQUFEO1dBQzlCLGNBQUEsS0FBa0I7RUFEWSxDQW5GaEM7RUFzRkEsZ0NBQUEsRUFBbUMsU0FBQyxjQUFEO1dBQ2pDLGNBQUEsS0FBa0I7RUFEZSxDQXRGbkM7RUF5RkEsaUJBQUEsRUFBb0IsU0FBQyxPQUFEO0lBQ2xCLElBQW1DLGVBQW5DO01BQUEsT0FBQSxHQUFVLE9BQU8sQ0FBQyxXQUFSLENBQUEsRUFBVjs7SUFDQSxJQUFrQixPQUFBLEtBQWEsSUFBYixJQUFBLE9BQUEsS0FBbUIsSUFBckM7QUFBQSxhQUFPLFFBQVA7O0lBQ0EsSUFBaUIsT0FBQSxLQUFhLElBQWIsSUFBQSxPQUFBLEtBQW1CLElBQXBDO0FBQUEsYUFBTyxPQUFQOztJQUNBLElBQW9CLE9BQUEsS0FBYSxJQUFiLElBQUEsT0FBQSxLQUFtQixJQUFuQixJQUFBLE9BQUEsS0FBeUIsSUFBekIsSUFBQSxPQUFBLEtBQStCLElBQS9CLElBQUEsT0FBQSxLQUFxQyxJQUFyQyxJQUFBLE9BQUEsS0FBMkMsSUFBM0MsSUFBQSxPQUFBLEtBQWlELElBQXJFO0FBQUEsYUFBTyxVQUFQOztBQUNBLFdBQU87RUFMVyxDQXpGcEI7RUFnR0EsWUFBQSxFQUFjLFNBQUE7QUFDWixRQUFBO0lBQUEsaUJBQUEsR0FBb0Isb0JBQUEsQ0FBQTtJQUNwQixJQUFHLHlCQUFIO2FBQ0UsSUFBSSxDQUFDLFNBQUwsQ0FBZSw0REFBZixFQUE2RTtRQUFDLG1CQUFBLEVBQXFCLGlCQUF0QjtPQUE3RSxFQURGO0tBQUEsTUFBQTthQUdFLElBQUksQ0FBQyxTQUFMLENBQWUsbUNBQWYsRUFIRjs7RUFGWSxDQWhHZDtFQXVHQSxvQkFBQSxFQUFzQixTQUFBO0FBQ3BCLFFBQUE7SUFBQSxRQUFBLHFEQUF1QyxDQUFFO0lBQ3pDLElBQUcsd0dBQUg7QUFDSSxhQUFPLFlBQWEsQ0FBQSxRQUFBLENBQVMsQ0FBQyxPQURsQzs7RUFGb0IsQ0F2R3RCO0VBNEdBLFFBQUEsRUFBVSxTQUFDLEdBQUQ7V0FDVCxhQUFBLElBQVEsQ0FBQyxHQUFBLEtBQU8sSUFBUCxJQUFlLEdBQUEsS0FBTyxNQUF2QjtFQURDLENBNUdWO0VBK0dBLFlBQUEsRUFBYyxTQUFBO3lFQUNaLFdBQVcsQ0FBRSxzQ0FBYixJQUE2QyxDQUFJLElBQUEsQ0FBQTtFQURyQyxDQS9HZDtFQWtIQSxZQUFBLEVBQWMsU0FBQyxRQUFEO0lBQ1osWUFBQSxDQUFhLFFBQWI7V0FDQSxlQUFBLENBQWdCLFFBQWhCO0VBRlksQ0FsSGQ7RUFzSEEsa0JBQUEsRUFBb0IsU0FBQyxRQUFEO0lBQ2xCLGVBQUEsQ0FBZ0IsUUFBaEI7V0FDQSxjQUFBLENBQWUsUUFBZjtFQUZrQixDQXRIcEI7RUEwSEEsWUFBQSxFQUFjLFNBQUMsUUFBRDtJQUNaLGVBQUEsQ0FBZ0IsUUFBaEI7V0FDQSxZQUFBLENBQWEsUUFBYjtFQUZZLENBMUhkO0VBOEhBLFlBQUEsRUFBYyxTQUFDLFFBQUQ7V0FDWixrQkFBQSxDQUFtQixRQUFuQixFQUE2QixNQUE3QjtFQURZLENBOUhkO0VBaUlBLGNBQUEsRUFBZ0IsU0FBQyxRQUFEO1dBQ2Qsa0JBQUEsQ0FBbUIsUUFBbkIsRUFBNkIsZ0JBQTdCO0VBRGMsQ0FqSWhCO0VBb0lBLG9CQUFBLEVBQXNCLFNBQUMsUUFBRDtXQUNwQix1QkFBQSxDQUF3QixRQUF4QixFQUFrQyxnQkFBbEM7RUFEb0IsQ0FwSXRCO0VBdUlBLGVBQUEsRUFBaUIsU0FBQyxRQUFEO1dBQ2YsdUJBQUEsQ0FBd0IsUUFBeEIsRUFBa0MsTUFBbEM7RUFEZSxDQXZJakI7RUEwSUEsZUFBQSxFQUFpQixTQUFDLFFBQUQ7V0FDZix1QkFBQSxDQUF3QixRQUF4QixFQUFrQyxNQUFsQztFQURlLENBMUlqQjtFQTZJQSxZQUFBLEVBQWMsU0FBQyxRQUFEO1dBQ1osa0JBQUEsQ0FBbUIsUUFBbkIsRUFBNkIsTUFBN0I7RUFEWSxDQTdJZDtFQWdKQSxrQkFBQSxFQUFvQixTQUFDLFFBQUQ7V0FDbEIsa0JBQUEsQ0FBbUIsUUFBbkIsRUFBNkIsYUFBN0I7RUFEa0IsQ0FoSnBCO0VBbUpBLG9CQUFBLEVBQXNCLFNBQUMsUUFBRDtXQUNwQixrQkFBQSxDQUFtQixRQUFuQixFQUE2QixZQUE3QjtFQURvQixDQW5KdEI7RUFzSkEsd0JBQUEsRUFBMEIsU0FBQyxRQUFEO1dBQ3hCLGtCQUFBLENBQW1CLFFBQW5CLEVBQTZCLDJCQUE3QjtFQUR3QixDQXRKMUI7RUF5SkEscUJBQUEsRUFBdUIsU0FBQyxRQUFEO1dBQ3JCLHVCQUFBLENBQXdCLFFBQXhCLEVBQWtDLGFBQWxDO0VBRHFCLENBekp2QjtFQTRKQSx1QkFBQSxFQUF5QixTQUFDLFFBQUQ7V0FDdkIsdUJBQUEsQ0FBd0IsUUFBeEIsRUFBa0MsWUFBbEM7RUFEdUIsQ0E1SnpCO0VBK0pBLDJCQUFBLEVBQTZCLFNBQUMsUUFBRDtXQUMzQix1QkFBQSxDQUF3QixRQUF4QixFQUFrQywyQkFBbEM7RUFEMkIsQ0EvSjdCO0VBa0tBLDBCQUFBLEVBQTRCLFNBQUMsUUFBRCxFQUFXLE9BQVg7V0FDMUIsa0JBQUEsQ0FBbUIsUUFBbkIsRUFBNkIsTUFBTSxDQUFDLHlCQUFwQyxFQUErRCxPQUEvRDtFQUQwQixDQWxLNUI7RUFxS0Esa0JBQUEsRUFBb0IsU0FBQyxRQUFELEVBQVcsU0FBWDtXQUNsQixrQkFBQSxDQUFtQixRQUFuQixFQUE2QixNQUFNLENBQUMsaUJBQXBDLEVBQXVELFNBQXZEO0VBRGtCLENBcktwQjtFQXdLQSx1QkFBQSxFQUF5QixTQUFDLFFBQUQsRUFBVyxTQUFYO1dBQ3ZCLGtCQUFBLENBQW1CLFFBQW5CLEVBQTZCLE1BQU0sQ0FBQyxzQkFBcEMsRUFBNEQsU0FBNUQ7RUFEdUIsQ0F4S3pCO0VBMktBLGtCQUFBLEVBQW9CLFNBQUMsUUFBRCxFQUFXLGlCQUFYLEVBQThCLFdBQTlCO0lBQ2xCLFFBQUEsR0FBVyxnQkFBQSxDQUFpQixRQUFqQjtXQUNYLENBQUMsQ0FBQyxJQUFGLENBQU8sUUFBUCxFQUFpQixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsT0FBRCxFQUFVLEtBQVY7ZUFDZixpQkFBQSxDQUFrQixPQUFsQixFQUEyQixXQUEzQjtNQURlO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFqQjtFQUZrQixDQTNLcEI7RUFpTEEsaUJBQUEsRUFBbUIsU0FBQyxPQUFELEVBQVUsU0FBVjtXQUNqQixPQUFPLENBQUMsUUFBUixDQUFpQixTQUFqQjtFQURpQixDQWpMbkI7RUFvTEEseUJBQUEsRUFBMkIsU0FBQyxPQUFELEVBQVUsT0FBVjtJQUN6QixPQUFPLENBQUMsVUFBUixDQUFtQixlQUFuQjtJQUNBLE9BQU8sQ0FBQyxVQUFSLENBQW1CLFVBQW5CO0lBQ0EsT0FBTyxDQUFDLElBQVIsQ0FBYSxVQUFiLEVBQXlCLE9BQXpCO1dBQ0EsT0FBTyxDQUFDLElBQVIsQ0FBYSxLQUFiLEVBQW9CLE9BQXBCO0VBSnlCLENBcEwzQjtFQTBMQSxzQkFBQSxFQUF3QixTQUFDLE9BQUQsRUFBVSxTQUFWO1dBQ3RCLE9BQU8sQ0FBQyxXQUFSLENBQW9CLFNBQXBCO0VBRHNCLENBMUx4QjtFQTZMQSxnQkFBQSxFQUFrQixTQUFDLFFBQUQ7SUFDaEIsSUFBRyxDQUFDLENBQUMsT0FBRixDQUFVLFFBQVYsQ0FBSDthQUE0QixTQUE1QjtLQUFBLE1BQUE7YUFBMEMsQ0FBQyxRQUFELEVBQTFDOztFQURnQixDQTdMbEI7RUFnTUEsWUFBQSxFQUFjLENBQUEsU0FBQSxLQUFBO1dBQUEsU0FBQyxJQUFELEVBQU8sU0FBUCxFQUFrQixPQUFsQixFQUEyQixRQUEzQixFQUFxQyxpQkFBckM7TUFDWixJQUFJLENBQUMsY0FBTCxHQUFzQixrQkFBa0IsQ0FBQyxZQUFuQixDQUFBO2FBQ3RCLHFDQUFBLENBQXVDLFNBQUE7QUFDckMsWUFBQTtRQUFBLGtCQUFrQixDQUFDLFdBQW5CLENBQStCLFFBQS9CLEVBQXlDLGlCQUF6QztRQUNBLEdBQUEsR0FBUyxNQUFNLENBQUMsY0FBUixHQUF1QjtRQUMvQixNQUFBLEdBQVM7UUFDVCxRQUFBLEdBQ0U7VUFBQSxZQUFBLEVBQWMsSUFBZDtVQUNBLElBQUEsMENBQXdCLENBQUUsV0FEMUI7O1FBRUYsV0FBVyxDQUFDLEdBQVosQ0FBZ0Isc0JBQWhCLEVBQXdDO1VBQUMsTUFBQSxFQUFRLFFBQVQ7U0FBeEM7ZUFDQSxnQkFBZ0IsQ0FBQyxJQUFqQixDQUFzQixHQUF0QixFQUEyQixNQUEzQixFQUFtQyxJQUFuQyxFQUF5QyxTQUF6QyxFQUFvRCxPQUFwRCxFQUE2RCxLQUE3RDtNQVJxQyxDQUF2QztJQUZZO0VBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQWhNZDtFQTZNQSxrQkFBQSxFQUFvQixTQUFBO0FBQ2xCLFFBQUE7SUFBQSxvQkFBQSxHQUF1QixDQUFBLENBQUUsbUJBQUYsQ0FBc0IsQ0FBQyxJQUF2QixDQUE0QixnQkFBNUI7SUFDdkIsSUFBZSx1QkFBQSxDQUF3QixvQkFBeEIsQ0FBZjtBQUFBLGFBQU8sS0FBUDs7SUFDQSxnQkFBQSxHQUFtQixDQUFBLENBQUUsT0FBRixDQUFVLENBQUMsSUFBWCxDQUFnQixtQkFBaEI7SUFDbkIsSUFBZSx1QkFBQSxDQUF3QixnQkFBeEIsQ0FBZjtBQUFBLGFBQU8sS0FBUDs7QUFDQSxXQUFPO0VBTFcsQ0E3TXBCO0VBb05BLHVCQUFBLEVBQXlCLFNBQUMsY0FBRDtBQUN2QixRQUFBO0lBQUEsY0FBQSx3RUFBeUMsQ0FBRTtXQUMzQyx3QkFBQSxJQUFvQix3QkFBcEIsSUFBd0MsY0FBYyxDQUFDLFFBQWYsQ0FBd0IsY0FBeEI7RUFGakIsQ0FwTnpCO0VBd05BLHVCQUFBLEVBQXlCLFNBQUMsZ0JBQUQ7QUFDdkIsUUFBQTtJQUFBLGdCQUFBLHdFQUEyQyxDQUFFO1dBQzdDLDBCQUFBLElBQXNCLDBCQUF0QixJQUE0QyxnQkFBZ0IsQ0FBQyxRQUFqQixDQUEwQixnQkFBMUI7RUFGckIsQ0F4TnpCOzs7QUE0TkYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
